import { useEffect, useState } from 'react'

type IdleWindow = Window & {
  requestIdleCallback?: (cb: () => void, opts?: { timeout?: number }) => number
  cancelIdleCallback?: (handle: number) => void
}

/**
 * Defers purely decorative work (confetti, floating doodles) until the browser
 * is idle, with a 200 ms timeout fallback. Keeps the first paint free for the
 * hero content without changing anything the user eventually sees.
 */
export function useIdleReady(): boolean {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const w = window as IdleWindow
    let idleHandle: number | undefined
    let timeoutHandle: number | undefined

    const start = () => setReady(true)

    if (typeof w.requestIdleCallback === 'function') {
      idleHandle = w.requestIdleCallback(start, { timeout: 200 })
    } else {
      timeoutHandle = window.setTimeout(start, 200)
    }

    return () => {
      if (idleHandle !== undefined && typeof w.cancelIdleCallback === 'function') {
        w.cancelIdleCallback(idleHandle)
      }
      if (timeoutHandle !== undefined) window.clearTimeout(timeoutHandle)
    }
  }, [])

  return ready
}
